import { type FC } from 'react';
import { Stack, Text } from '@mantine/core';
import { formatOrder, getPayoutOrderSplitRelation, type PayoutTraderOrder, type PayoutOrder } from '~/entities/payout';
import { KeyValuePair } from '~/shared/ui/KeyValuePair';
import { CopyInput } from '~/shared/ui/CopyInput';
import { RelatedOrderValue, Requisites } from './components';

interface OrderProps {
    order: PayoutOrder | PayoutTraderOrder;
}

export const OrderDetails: FC<OrderProps> = ({ order }) => {
    const splitRelation = getPayoutOrderSplitRelation(order);

    return (
        <Stack
            align='stretch'
            gap='xs'
        >
            {order.id?.value && (
                <KeyValuePair
                    label='ID'
                    value={<CopyInput value={order.id?.value} />}
                />
            )}

            {splitRelation.parentOrderId && (
                <KeyValuePair
                    label='Родительский ордер'
                    value={<RelatedOrderValue orderId={splitRelation.parentOrderId} />}
                />
            )}

            {order.amount?.value && (
                <KeyValuePair
                    label='Сумма'
                    value={<Text>{order.amount.value}</Text>}
                />
            )}

            {order.currency && (
                <KeyValuePair
                    label='Валюта'
                    value={<Text>{formatOrder.currency(order.currency)}</Text>}
                />
            )}

            {order.rate?.value && (
                <KeyValuePair
                    label='Курс'
                    value={<Text>{order.rate?.value}</Text>}
                />
            )}

            {order.status && (
                <KeyValuePair
                    label='Статус'
                    value={<Text>{formatOrder.status(order.status)}</Text>}
                />
            )}

            {'publicStatus' in order && order.publicStatus && (
                <KeyValuePair
                    label='Публичный статус'
                    value={<Text>{formatOrder.publicStatus(order.publicStatus)}</Text>}
                />
            )}

            {'priority' in order && order.priority && (
                <KeyValuePair
                    label='Приоритет'
                    value={<Text>{formatOrder.priority(order.priority)}</Text>}
                />
            )}

            {order.createdAt && (
                <KeyValuePair
                    label='Дата создания'
                    value={<Text>{formatOrder.date(order.createdAt)}</Text>}
                />
            )}

            {order.expiresAt && (
                <KeyValuePair
                    label='Дата истечения'
                    value={<Text>{formatOrder.date(order.expiresAt)}</Text>}
                />
            )}

            {order.traderName?.value && (
                <KeyValuePair
                    label='Трейдер'
                    value={order.traderName.value}
                />
            )}

            {order.parentOrderId && (
                <KeyValuePair
                    label='Часть'
                    value={<Text>{formatOrder.splitPart(order.splitPart)}</Text>}
                />
            )}

            <Requisites requisiteV2={order.requisiteV2} />
        </Stack>
    );
};
